import { IEcmCategoryModel } from '../pages/certificate-list-view/cetificate-list/add-new-certificate/rp-library/shared/interfaces/ecm-category-model/IECMCategoryModel'
import { ResultModel } from '../shared/models/service-models/Result.model'
import RequestFactory from './RequestFactory'

const ecmIntegrationUrl = process.env.REACT_APP_GMAE2E_URL

const EcmIntegrationService = {
  createEcmFolder: async (model: any) =>
    await RequestFactory.post(ecmIntegrationUrl, '/api/ecm-integration/create-ecm-folder', model),
  downloadEcmFile: async (nodeId: string) =>
    await RequestFactory.downloadGet(ecmIntegrationUrl, `/api/ecm-integration/download/${nodeId}`),

  getCategoryAttributeList: async (): Promise<ResultModel<IEcmCategoryModel[]>> =>
    await RequestFactory.get(ecmIntegrationUrl, '/api/ecm-integration/get-category-attribute-list'),

  getRPCategoryAttributeList: async (): Promise<ResultModel<IEcmCategoryModel[]>> =>
    await RequestFactory.get(
      ecmIntegrationUrl,
      '/api/ecm-integration/get-rp-category-attribute-list'
    ),
}

export default EcmIntegrationService
